export default "__VITE_ASSET__B_NQJ_6j__"